import styled from "styled-components";

export const Footer = styled.div`
  color: #fff;
  background-color: #333;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
  width:100vw;
  height:5vh;
  font-size: 10pt;
  text-align: center;
  padding: 10px 0 0 0;
`;

export const SocialMedia = styled.div`
  color: #fff;
  background-color: #333;
  width:100vw;
  height:12vh;
  font-size: 15pt;
  font-weight: bold;
  text-align: center;
  padding: 10px 0px;
`;